import { render, staticRenderFns } from "./TermsAndConditionTabs.vue?vue&type=template&id=36a36808"
import script from "./TermsAndConditionTabs.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports